import * as React from 'react'

import "./style.scss"

import {AppContext} from "../../../Context/AppContext"

import {postier} from "./Postier"
import { Download } from '../../Utils/Download'
import { Create } from './Create'
import { ReactElement, useContext, useEffect, useState } from 'react'

export function Flow(): ReactElement {

    const {token,site,client,setLoading, setErrors, role} = useContext(AppContext)
    const [event, setEventData] = useState([])
    const [page, setPage] = useState<string>("main")

    const setEvents = (arg)=>{
        setLoading(false)
        setEventData(arg)
    }

    useEffect(() => {
        setLoading(true)
        site?postier.getMesures(token,client,site,setEvents, setErrors):null;
    }, [site])

    const camera = event.map(cam=>{
    
    const fromDate = new Date(cam.FromDate)
    const toDate = new Date(cam.ToDate)

    
    return <tr key={Math.random()} className="line" >
            <td>{cam.SourceEntityID}</td>
            <td>{cam.DestinationEntityID}</td>
            <td>{cam.Coef}</td>
            <td>{fromDate.toLocaleDateString()}</td>
            <td>{toDate.toLocaleDateString()}</td>
        </tr>
        })

    const handleCreate = () => {
        setPage('create')
        document.getElementById("flow-buttons").style.display = 'none'
    }

    const handleBackToMenu = () => {
        setPage('main')
        document.getElementById("flow-buttons").style.display = 'flex'
    }

    return (

        <div className="event">
            {page !== "create" ? role !== 'Viewer' && <button className="download" onClick={handleCreate}>Créer un coefficient</button> : <button onClick={handleBackToMenu}>Retour au menu</button>}
            {page === "main"&&<table id="table">
                        <thead>
                            <tr className="line" >
                                <td>Entity source</td>
                                <td>Entity destination</td>
                                <td>Coefficient</td>
                                <td>Début</td>
                                <td>Fin</td>
                            </tr>
                        </thead>
                        <tbody>
                            {camera}
                        </tbody>
                    </table>}
                {page === "create" && <Create setPage={setPage}/>}
                {page !== "create" && <Download id="table" clientCode={client.split(":")[0]} siteId={site.split(":")[0]} type={"coeff_flow"} />}
        </div>

        
    )
}
